<template lang="pug">
el-container(id="Library-container")
  .el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll()
    .header-row(height='40px')
      span.header-title-underlined
        el-input.text-search(id="Library-searchInput" style="width:200px;", size="mini", v-model="searchString", clearable)
          i.el-icon-search.el-input__icon(slot='suffix')
      //- adding mode="library" - it will bring back bars/list view in future
      NaviButtons.float-right(id="Library-naviButtons" :side="side", :loading='loading', @reloadLeftComponent='reloadLeftComponent', @openActionsMenu='openActionsMenu')
      hr.header
    .top-row-container
      .path(id="Library-path")
        span.folder-name(
          v-if="backPath",
          v-for="(backPathItem, index) in backPath",
          :key="backPathItem.name"
          type="text",
          size="mini",
          @click="loadBackPathFolder(backPathItem, index)"
          )
            span(v-if="index > 0") {{backPathItem.name}}
            span.home(v-else, :title="$t('Library root folder')")
              font-awesome-icon(icon="home")
            font-awesome-icon.slash(icon="chevron-right")
        span.folder-name(
            type="text",
            size="mini",
            v-if="libraryFolder",
            @click="reloadData()"
          )
            span(v-if="backPath && backPath.length > 0") {{libraryFolder.name}}
            span.home(v-else, :title="$t('Library root folder')")
              font-awesome-icon(icon="home")
        .filter-by-type-button
          el-button-group
            el-button.view-mode(
              id="Library-viewModeButton",
              size="mini",
              type="text",
              @click="toggleViewMode()"
            )
              font-awesome-icon.muted(:icon="viewMode === 'thumb' ? 'bars' : 'expand'")
            el-button.view-mode(
              id="DeviceList-waitingContentApprovalFilter",
              @click='toggleViewModeUnlinked()',
              type="text",
              size='mini',
              :title='$t("Show only unassigned media")'
            )
              font-awesome-icon.warning(v-if='viewModeUnlinked === "unlinked"', icon="unlink")
              font-awesome-icon.warning(v-if='viewModeUnlinked === "linked"', icon="link")
              font-awesome-icon.muted(v-if='viewModeUnlinked === "all"', icon="link")
          FilterByTypeButton(id="Library-filterByTypeButton" :side="side", @setMediaTypeFilterActive='setMediaTypeFilterActive')
          SortButton(id="Library-sortButton" :side="side", @setMediaSortActive='setMediaSortActive')
    .library(id="Library-library" :class="{ 'reloading-folder': loading }", @click.self="clearMediaSelectedLeft; closeRightClickMenu()")
      .medium.back(
        v-if="backPath && backPath.length > 0 && viewMode === 'thumb'",
        type="text",
        :class='getMediumClass()',
        @dblclick="goBack()",
        id="Library-goBackButton"
      )
        .cell.thumbnail
          font-awesome-icon.thumb-image.icon(icon="chevron-left")
        .cell.name
          .text-library.medium-name {{$t('back')}}
      .medium(
          v-if="libraryFolder && libraryFolder.PlayListItems.length === 0 && !inRootFolder",
          type="text",
          :class='getMediumClass()',
          @dblclick="deleteEmptyFolder()",
          id="Library-deleteEmptyFolderButton"
        )
        .cell.thumbnail
          font-awesome-icon.thumb-image.icon(icon="folder-minus")
        .cell.name
          .text-library.medium-name {{$t('delete')}}
      .medium(
        v-for="folder in folders",
        :id="'Library-folder' + folder.id",
        type="text",
        draggable,
        :title='folder.Medium.name'
        :key="folder.Medium.id",
        :class='getMediumClass(folder.Medium)',
        v-on:dragstart="dragStart(folder.Medium, $event)",
        v-on:dragleave="dragLeaveFolder(folder.Medium, $event)",
        v-on:dragover="dragEnterFolder(folder.Medium, $event)",
        v-on:dragend="dragEnd(folder.Medium, $event)",
      )
        .cell.thumbnail
          font-awesome-icon.thumb-image.icon(
            :icon='selectedFolder && selectedFolder.id === folder.Medium.id ? "folder-open" : "folder"',
            @dblclick="loadFolder(folder.Medium)"
            @click='toggleMediumInSelectedMedia(folder.Medium, $event, folders); closeRightClickMenu();'
          )
        .cell.name
          .text-library.medium-name(
            v-if='!renamedFolder || renamedFolder.id !== folder.Medium.id',
            @dblclick="showRenameFolder(folder.Medium)"
          ) {{ viewMode === 'thumb' ? addzwspaces(formatName(folder.Medium.name)) : addzwspaces(folder.Medium.name) }}
          input.rename-input(
            v-if='renamedFolder && (folder.Medium.id === renamedFolder.id)',
            v-model='renamedFolder.name',
            :id="'Library-renameFolderButton' + folder.id",
            :ref='"input_raname_folder" + folder.Medium.id'
            @blur="renameFolder()",
            @keyup.enter="renameFolder()"
          )
        .cell.params(v-if='viewMode === "row"')
          //- .layout-info-row
          //-   pre {{ folder.PlayListItems }}
      .medium(
        type="text",
        v-for="layout in layouts",
        :id="'Library-layout' + layout.id",
        :key="layout.Medium.id",
        draggable,
        :title='layout.Medium.name',
        v-on:dragstart="dragStart(layout.Medium, $event)",
        v-on:dragend="dragEnd(layout.Medium, $event)",
        v-on:dragenter="dragEnter(layout.Medium, $event)",
        :class='getMediumClass(layout.Medium)',
        @dblclick='handleDblClick(layout.Medium)',
        @click.stop='toggleMediumInSelectedMedia(layout.Medium, $event, layouts); closeRightClickMenu();'
        @contextmenu='openRightClickMenu(layout.Medium, $event)',
      )
        .cell.thumbnail
          font-awesome-icon.thumb-image.icon(icon="layer-group", :class="getClassSelectedForMedium(layout.Medium)", @click='playMediumLocal(layout)')
        .cell.name.selectable
          .text-library.medium-name(:class="getClassSelectedForMedium(layout.Medium)") {{ viewMode === 'thumb' ? addzwspaces(formatName(layout.Medium.name)) : addzwspaces(layout.Medium.name) }}
          font-awesome-icon.tagged(v-if='mediaFilteredByTag.includes(layout.Medium.id)', icon="tags")
        .cell.params(v-if='viewMode === "row"')
          .layout-info-row {{ layout.Medium.playListLayoutWidth }}x{{ layout.Medium.playListLayoutHeight }}px
        //- .layout-info-row {{ $store.state.Medium.media_list.find(m => m.id === playlist.Medium.id).PlayListItems.length }} {{ $t(' zones') }}
        .cell.medium-tags(v-if='viewMode === "row"')
          MediumTagsShortInfo(:mediumId='layout.Medium.id')
        .cell.medium-timeData(v-if='viewMode === "row"')
          .row(:title='$t("Updated")')
            span {{ $moment(layout.Medium.updatedAt).format('YYYY-MM-DD HH:mm') }} &nbsp;
            font-awesome-icon.icon-time(icon="save")
          .row(:title='$t("Created")')
            span {{ $moment(layout.Medium.createdAt).format('YYYY-MM-DD HH:mm') }} &nbsp;
            font-awesome-icon.icon-time(icon="folder-plus")
      .medium(
        type="text",
        v-for='playlist in playlists',
        :id="'Library-playlist' + playlist.id",
        :key='playlist.Medium.id',
        draggable,
        :title='playlist.Medium.name',
        v-on:dragstart='dragStart(playlist.Medium, $event)',
        v-on:dragend='dragEnd(playlist.Medium, $event)',
        v-on:dragenter='dragEnter(playlist.Medium, $event)',
        :class='getMediumClass(playlist.Medium)',
        @dblclick='handleDblClick(playlist.Medium)',
        @click.stop='toggleMediumInSelectedMedia(playlist.Medium, $event, playlists); closeRightClickMenu();',
        @contextmenu='openRightClickMenu(playlist.Medium, $event)',
      )
        .cell.thumbnail
          font-awesome-icon.thumb-image.icon(:icon="playlist.Medium.type === 'PlayList' ? 'film' : 'camera-retro'", :class="getClassSelectedForMedium(playlist.Medium)", @click='playMediumLocal(playlist)')
        .cell.name.selectable
          .text-library.medium-name(:class="getClassSelectedForMedium(playlist.Medium)") {{ viewMode === 'thumb' ? addzwspaces(formatName(playlist.Medium.name)) : addzwspaces(playlist.Medium.name) }}
          font-awesome-icon.tagged(v-if='mediaFilteredByTag.includes(playlist.Medium.id)', icon="tags")
        .cell.params(v-if='viewMode === "row"')
          .playlist-info-row {{ msToDuration(playlist.Medium.playListDurationMs) }}
          //- .playlist-info-row {{ $store.state.Medium.media_list.find(m => m.id === playlist.Medium.id).PlayListItems.length }} {{ $t(' elements') }}
        .cell.medium-tags(v-if='viewMode === "row"')
          MediumTagsShortInfo(:mediumId='playlist.Medium.id')
        .cell.medium-timeData(v-if='viewMode === "row"')
          .row(:title='$t("Updated")')
            span {{ $moment(playlist.Medium.updatedAt).format('YYYY-MM-DD HH:mm') }} &nbsp;
            font-awesome-icon.icon-time(icon="save")
          .row(:title='$t("Created")')
            span {{ $moment(playlist.Medium.createdAt).format('YYYY-MM-DD HH:mm') }} &nbsp;
            font-awesome-icon.icon-time(icon="folder-plus")
      .medium(
        v-for='file in files',
        :id="'Library-file' + file.id",
        :key='file.Medium.id',
        type="text",
        draggable,
        :title='file.Medium.name',
        @dragstart='dragStart(file.Medium, $event)',
        @dragend='dragEnd(file.Medium, $event)',
        @dragenter='dragEnter(file.Medium, $event)',
        :class='getMediumClass(file.Medium)',
        @dblclick='handleDblClick(file.Medium)',
        @click.stop='toggleMediumInSelectedMedia(file.Medium, $event, files); closeRightClickMenu();',
        @contextmenu='openRightClickMenu(file.Medium, $event)',
      )
        .cell.thumbnail
          img.thumb-image(:src="getMediumThumbnailPath(file)", @click='playMediumLocal(file)')
        .cell.name.selectable
          .text-library.medium-name(:class="getClassSelectedForMedium(file.Medium)", :title='file.Medium.name') {{ viewMode === 'thumb' ? addzwspaces(formatName(file.Medium.name)) : addzwspaces(file.Medium.name) }}
          font-awesome-icon.tagged(v-if='mediaFilteredByTag.includes(file.Medium.id)', icon="tags")
        .cell.params(v-if='viewMode === "row" && !showTags')
          .param {{ file.File.originalMimeType }}
          .param {{ file.File.originalWidthPixels }}x{{ file.File.originalHeightPixels }}px
          .param(v-if="file.File.originalDurationMs && !file.Medium.playDurationMs") {{ msToDuration(file.File.originalDurationMs) }}
          .param.warning(v-if="file.Medium.playDurationMs") {{ msToDuration(file.Medium.playDurationMs) }}
          .param {{ humanFileSize(file.File.currentSize) }}
        .cell.medium-tags(v-if='viewMode === "row" && !showTags')
          MediumTagsShortInfo(:mediumId='file.Medium.id')
        .cell.medium-timeData(v-if='viewMode === "row"')
          .row(:title='$t("Updated")')
            span {{ $moment(file.Medium.updatedAt).format('YYYY-MM-DD HH:mm') }} &nbsp;
            font-awesome-icon.icon-time(icon="save")
          .row(:title='$t("Created")')
            span {{ $moment(file.Medium.createdAt).format('YYYY-MM-DD HH:mm') }} &nbsp;
            font-awesome-icon.icon-time(icon="folder-plus")
      .upload
        FileUpload(id="Library-fileUpload" ref="fileUpload", :folder="libraryFolder", @uploadFinished='reloadData()', @reloadLeftComponent='reloadLeftComponent', @loadPathInLibrary='loadPath')
        FileList(@file-Converted='reloadData()')
    p(v-if='selectedFolder')
      span {{ selectedFolder.name }}
  el-dialog(:close-on-click-modal="false",
    :visible.sync="createFolderDialogVisible",
    @close='closeCreateFolderDialog()'
  )
    p
      h4 {{$t('Create folder')}}
      hr.header
      el-form(id="Library-createFolderForm" ref='form', @submit.native.prevent="createFolder()")
        el-form-item(:label='$t("Folder name:")')
          el-input(id="Library-createFolderFormNameInput" size="mini", v-model='newFolder.name', ref='newFolderName')
        el-button.float-right(
          id="Library-createFolderFormSubmit",
          type="success",
          size="mini",
          @click="createFolder()"
        )
          span {{$t('Create')}} &nbsp;&nbsp;&nbsp;
            font-awesome-icon(icon="folder-plus")
        br
  el-dialog(:close-on-click-modal="false",
    :visible.sync="mediumBasicEditorVisible",
    @close='closeMediumBasicEditor()',
    append-to-body, width="80%"
  )
    MediumBasicEditor(id="Library-mediumBasicEditor" v-if='mediumInFocus', :mediumId='mediumInFocus.id', @close='closeMediumBasicEditor()')
  el-dialog(:close-on-click-modal="false",
    :visible.sync="extensionConfigEditorVisible",
    @close='closeExtensionConfigEditor()',
    append-to-body, width="80%"
  )
    ExtensionConfigEditor(id="Library-extensionConfigEditor" v-if='mediumInFocus', :mediumId='mediumInFocus.id', @close='closeExtensionConfigEditor()')
  el-dialog(:close-on-click-modal="false", :visible.sync="playMediumVisible", @close='playMediumVisible = false; playedMedium = undefined',  append-to-body, width='65%')
    Player(:playedMedium='playedMedium', @close-PlayMedium="closePlayMedium()")
  RightClickMediumBrowserMenu(
    ref='RightClickMediumBrowserMenu',
    :libraryFolder='libraryFolder',
    @rightClickAction='rightClickAction'
  )
</template>

<script>
import Vue from 'vue'
import FileUpload from '../File/Upload'
import FileList from '../File/List'
import FileShortInfo from '../File/ShortInfo'
import ListItemMixin from './ListItem.mixin'
import AssignMixin from '../Linker/assign2.mixin'
import MediaUtilsMixin from '../Common/mediaUtils.mixin'
import TextUtilsMixin from '../Common/textUtils.mixin'
import NaviButtons from './NaviButtons'
import RightClickMediumBrowserMenu from './RightClickMediumBrowserMenu'
import MediumBasicEditor from './MediumBasicEditor'
import MediumTagsShortInfo from './MediumTagsShortInfo'
import ExtensionConfigEditor from './ExtensionConfigEditor'
import FilterByTypeButton from './FilterByTypeButton'
import SortButton from './SortButton'
import Player from './../File/Player'

export default {
  mixins: [ListItemMixin, AssignMixin, MediaUtilsMixin, TextUtilsMixin],
  components: {
    FileUpload,
    FileShortInfo,
    FileList,
    NaviButtons,
    MediumBasicEditor,
    MediumTagsShortInfo,
    ExtensionConfigEditor,
    FilterByTypeButton,
    SortButton,
    RightClickMediumBrowserMenu,
    Player
  },
  data () {
    return {
      errors: {
      },
      viewMode: this.$store.state.User.user.mediumListViewActive ? 'row' : 'thumb',
      libraryFolder: undefined,
      renamedFolder: undefined,
      backPath: [],
      loading: false,
      playItemsSelected: [],
      createFolderDialogVisible: false,
      uploadFilesDialogVisible: false,
      mediumBasicEditorVisible: false,
      extensionConfigEditorVisible: false,
      newFolder: { name: '', type: 'PlayListLibraryFolder', test: false },
      mediumInFocus: undefined,
      folderAlreadyExistsWithName: false,
      selectedFolder: undefined,
      mediaTypeFilterActive: '',
      sortColumnActive: 'Name',
      playMediumVisible: false,
      playedMedium: undefined,
      viewModeUnlinked: 'all',
      showTags: false
    }
  },
  props: ['library'],
  async created () {
    if (this.library === '1') await this.loadData('created')
    this.$store.dispatch('Medium/clearMediaSelectedLeft')
    if (this.folderSelected.name && this.folderSelected.backPath) {
      this.libraryFolder = this.folderSelected
      this.backPath = this.libraryFolder.backPath
    } else {
      this.loading = true
      const rootMedium = this.$store.state.Medium.media_list.find(medium => medium.type === 'PlayListLibraryRoot')
      this.$store.commit('User/SET_CHANGING_NETWORK_STATUS_MEDIA', 'Loading root folder...')
      this.libraryFolder = await this.$store.dispatch('Medium/getPlaylistContentSimple', { medium: rootMedium, omitCalculateDurations: this.omitCalculateDurations })
      setTimeout(() => {
        this.$store.commit('User/SET_CHANGING_NETWORK_STATUS_MEDIA', undefined)
      }, 500)
      this.loading = false
    }
  },
  watch: {
    libraryFolder: async function (newVal, oldVal) {
      if (!this.libraryFolder) return
      if (
        this.backPath &&
        this.backPath.length > 0
      ) {
        this.libraryFolder.backPath = JSON.parse(JSON.stringify(this.backPath))
      }
      const pathNames = this.backPath.map(p => p.name)
      pathNames.push(this.libraryFolder.name)
      pathNames[0] = this.$t(pathNames[0])
      this.$emit('loadedFolder', { library: this.library, name: this.libraryFolder.name, path: pathNames.join(' / ') })
      this.$store.dispatch('Medium/setSelectedLibraryFolder', this.libraryFolder)
    }
  },
  methods: {
    closePlayMedium () {
      this.playedMedium = undefined
      this.playMediumVisible = false
    },
    playMediumLocal (item) {
      if (this.viewMode === 'thumb') return
      this.playedMedium = item.Medium
      this.playMediumVisible = true
    },
    addzwspaces (string) {
      return string
        .replace('_', '\u200b_')
        .replace('.', '\u200b.')
        .replace('/', '\u200b/')
        .replace('&', '\u200b&')
    },
    toggleViewMode () {
      this.viewMode === 'thumb' ? this.viewMode = 'row' : this.viewMode = 'thumb'
      this.setViewPreference()
      if (this.viewMode === 'row') {
        this.$emit('reloadLeftComponent')
      }
    },
    toggleViewModeUnlinked () {
      switch (this.viewModeUnlinked) {
        case 'all':
          this.viewModeUnlinked = 'unlinked'
          break
        case 'unlinked':
          this.viewModeUnlinked = 'linked'
          break
        case 'linked':
          this.viewModeUnlinked = 'all'
          break
      }
    },
    async setViewPreference () {
      await Vue.axios.post('user/setViewPreference', {
        mediumListViewActive: !this.$store.state.User.user.mediumListViewActive
      })
      await this.$store.dispatch('User/getMe')
    },
    setMediaTypeFilterActive (type) {
      type === 'allMedia' ? this.mediaTypeFilterActive = '' : this.mediaTypeFilterActive = type
    },
    setMediaSortActive (column) {
      this.sortColumnActive = column
    },
    async loadPath (path) {
      const folderMedium = this.$store.state.Medium.media_list.find(medium => medium.id === parseInt(path[path.length - 2]))
      const backPath = []
      for (let index = 0; index < path.length - 2; index++) {
        const medium = this.$store.state.Medium.media_list.find(medium => medium.id === parseInt(path[index]))
        const backPathItem = await this.$store.dispatch('Medium/getPlaylistContentSimple', { medium, omitCalculateDurations: this.omitCalculateDurations })
        backPath.push(backPathItem)
      }
      this.backPath = backPath
      this.libraryFolder = { ...await this.$store.dispatch('Medium/getPlaylistContentSimple', { medium: folderMedium, omitCalculateDurations: this.omitCalculateDurations }), backPath }
      this.$store.dispatch('Medium/clearMediaSelectedLeft')
      this.$store.dispatch('Medium/addMediumSelectedLeft', this.$store.state.Medium.media_list.find(medium => medium.id === parseInt(path[path.length - 1])))
    },
    toggleTagFilterVisibility () {
      this.$store.dispatch('Medium/toggleTagFilterVisible')
    },
    getClassForTagFilter () {
      if (this.$store.state.Medium.media_filter[this.side].mediaTags.length > 0) {
        return 'active-filter-tags'
      }
    },
    rightClickAction (data) {
      if (data.action === 'editMedium') {
        this.mediumInFocus = data.medium
        this.mediumBasicEditorVisible = true
      } else if (data.action === 'configure') {
        this.mediumInFocus = data.medium
        this.extensionConfigEditorVisible = true
      } else {
        this.$emit('rightClickAction', data)
      }
    },
    openActionsMenu (data) {
      this.openRightClickMenu(data.medium, data.$event)
    },
    openRightClickMenu (medium, $event) {
      this.$refs.RightClickMediumBrowserMenu.openRightClickMenu(medium, $event)
      this.$emit('closeRightPanelContextMenu')
    },
    closeRightClickMenu () {
      this.$refs.RightClickMediumBrowserMenu.closeRightClickMenu()
      this.$emit('closeRightPanelContextMenu')
    },
    closeMediumBasicEditor () {
      this.mediumBasicEditorVisible = false
      this.mediumInFocus = undefined
      this.$emit('reloadLeftComponent')
    },
    closeExtensionConfigEditor () {
      this.extensionConfigEditorVisible = false
      this.mediumInFocus = undefined
    },
    triggerSelectFiles (type) {
      this.$refs.fileUpload.triggerSelectFiles(type)
    },
    formatName (name) {
      return this.shortenStringWithDots(name, 23)
    },
    clearMediaSelectedLeft ($event) {
      if (!$event.ctrlKey && !$event.metaKey) {
        this.$store.dispatch('Medium/clearMediaSelectedLeft')
      }
    },
    reloadLeftComponent () {
      this.$emit('reloadLeftComponent')
    },
    keyboardAction (params) {
      if (params === 'cutSelected') {
        this.cutItems()
      } else if (params === 'pasteSelected') {
        this.pasteItems()
      } else if (params === 'newFolder') {
        this.openCreateFolderDialog()
        this.$nextTick(() => this.$refs.newFolderName.focus())
      } else if (params === 'uploadMedia') {
        console.log('upload media shortcut not implemented')
      }
    },
    selectAll () {
      this.$store.dispatch(
        'Medium/setSelectedLeft',
        [
          ...this.files.map(file => file.Medium),
          ...this.playlists.map(playlist => playlist.Medium),
          ...this.layouts.map(layout => layout.Medium)
        ]
      )
      this.__setPlayitemsSelectedLeft()
    },
    selectNone () {
      this.$store.dispatch('Medium/clearMediaSelectedLeft')
    },
    async loadData (from) {
      this.libraryFolder = undefined
      this.loading = true
      if (this.$store.state.Medium.media_list.length < 1) {
        this.$store.commit('User/SET_CHANGING_NETWORK_STATUS_MEDIA', 'Loading media...')
        await this.$store.dispatch('Medium/getMediaList')
        this.$store.commit('User/SET_CHANGING_NETWORK_STATUS_MEDIA', 'Analyzing media...')
        await this.$store.dispatch('Medium/analyzeList')
      }
      // this.$store.dispatch('Medium/activateWsListener')
      this.loading = false
    },
    setLoading (boolean) {
      this.loading = boolean
    },
    getClassSelectedForMedium (medium) {
      return this.isSelectedLeft(medium) ? 'selected' : ''
    },
    getMediumClass (medium) {
      if (!medium) return `${this.viewMode} navigation-button`
      const isSelectedRight = this.isSelectedRight(medium) ? 'warning' : ''
      const isTestMedium = medium.test ? 'test-medium' : ''
      return this.isSelectedLeft(medium) ? `${isSelectedRight} ${isTestMedium} ${this.viewMode} selected` : `${isSelectedRight} ${isTestMedium} ${this.viewMode}`
    },
    async reloadData () {
      await this.$store.dispatch('Medium/getMediaList')
      await this.$store.dispatch('Medium/analyzeList')
      await this.reloadFolder(this.libraryFolder)
    },
    async deleteEmptyFolder () {
      let lastItemInPath = this.backPath[ this.backPath.length - 1 ]
      let folderToBeDeletedPlayListItemIndex = lastItemInPath.PlayListItems.findIndex(pli => pli.Medium.id === this.libraryFolder.id)
      let folderToBeDeletedPlayListItemId = lastItemInPath.PlayListItems[folderToBeDeletedPlayListItemIndex].id
      await this.$store.dispatch('Medium/deleteEmptyFolderMedium', [this.libraryFolder.id, folderToBeDeletedPlayListItemId])
      await this.goBack()
    },
    async __movePlayItemsToFolder (destinationFolderId, isDropped = false) {
      if (isDropped) this.__setPlayitemsSelectedLeft()
      const itemsToMoveIds = this.$store.state.Medium.playitems_selected_left.map(item => item.id)
      // Do not __move if empty playitems
      if (itemsToMoveIds.length < 1) return
      await Vue.axios
        .post('playlistitem/movePlayItemsInLibrary', { playListId: destinationFolderId, playListItemIds: itemsToMoveIds })
      this.playItemsSelected = []
      this.selectedFolder = undefined
      await this.reloadFolder(this.libraryFolder)
    },
    __setPlayitemsSelectedLeft () {
      this.playItemsSelected = []
      for (const mediumSelected of this.$store.state.Medium.media_selected_left) {
        const playitem = this.libraryFolder.PlayListItems.find(pi => pi.Medium.id === mediumSelected.id)
        this.playItemsSelected.push(playitem)
      }
      this.$store.commit('Medium/SET_PLAYITEMS_SELECTED_LEFT', this.playItemsSelected)
    },
    async pasteItems () {
      await this.__movePlayItemsToFolder(this.libraryFolder.id)
    },
    cutItems () {
      this.__setPlayitemsSelectedLeft()
      this.$store.dispatch('Medium/clearMediaSelectedLeft')
    },
    closeCreateFolderDialog () {
      this.newFolder.name = ''
      this.createFolderDialogVisible = false
    },
    openCreateFolderDialog () {
      this.createFolderDialogVisible = true
      this.$nextTick(() => this.$refs.newFolderName.focus())
    },

    async createFolder () {
      if (this.newFolder.name === '') return

      this.newFolder.test = this.libraryFolder.test
      this.newFolder.libraryFolderId = this.libraryFolder.id
      let FolderPlaylistId = await this.$store.dispatch('Medium/createPlaylistLibraryFolder', this.newFolder)
      await this.$store.dispatch('Medium/assignMediumToPlaylist', [this.libraryFolder.id, FolderPlaylistId])
      this.libraryFolder = await this.$store.dispatch('Medium/getPlaylistContentSimple', { medium: this.libraryFolder, omitCalculateDurations: this.omitCalculateDurations })
      this.closeCreateFolderDialog()
    },
    async loadBackPathFolder (medium, index) {
      this.loading = true
      this.backPath.length = index
      this.libraryFolder = undefined
      this.$store.dispatch('Medium/clearMediaSelectedLeft')
      this.libraryFolder = await this.$store.dispatch('Medium/getPlaylistContentSimple', { medium, omitCalculateDurations: this.omitCalculateDurations })
      this.loading = false
    },
    async showRenameFolder (medium) {
      this.renamedFolder = JSON.parse(JSON.stringify(medium))
      this.$nextTick(() => this.$refs[`input_raname_folder${medium.id}`][0].focus())
    },
    async renameFolder (medium) {
      await Vue.axios
        .patch(`medium/${this.renamedFolder.id}`, { name: this.renamedFolder.name })
        .then(async response => {
        })
        .catch(error => {
          this.$store.dispatch('Error/setAxiosError', error.response)
        })
      this.renamedFolder = undefined
      await this.reloadFolder(this.libraryFolder)
    },
    async loadFolder (medium) {
      this.loading = true
      if (!this.backPath) this.backPath = []
      this.backPath.push(this.libraryFolder)
      this.libraryMedium = undefined
      this.libraryFolder = undefined
      this.$store.dispatch('Medium/clearMediaSelectedLeft')
      this.libraryFolder = await this.$store.dispatch('Medium/getPlaylistContentSimple', { medium, omitCalculateDurations: this.omitCalculateDurations })

      this.loading = false
    },
    async reloadFolder (medium) {
      this.loading = true
      if (!medium) medium = this.libraryFolder
      this.$store.dispatch('Medium/clearMediaSelectedLeft')
      this.libraryFolder = await this.$store.dispatch('Medium/getPlaylistContentSimple', { medium, omitCalculateDurations: this.omitCalculateDurations })

      this.loading = false
    },
    async goBack (medium) {
      this.libraryFolder = undefined
      this.$store.dispatch('Medium/clearMediaSelectedLeft')
      this.libraryFolder = await this.$store.dispatch('Medium/getPlaylistContentSimple', { medium: this.backPath[ this.backPath.length - 1 ], omitCalculateDurations: this.omitCalculateDurations })
      this.backPath.pop()
    },
    loadEditMediumInMediaEditor (medium) {
      this.$store.dispatch('Medium/clearBreadcrumbs')
      this.$store.dispatch('Medium/addMediumIdToBreadcrumbs', medium.id)
      this.$emit('loadEditMediumInMediaEditor', medium)
    },
    handleDblClick (medium) {
      if (medium.type.startsWith('PlayList')) {
        this.loadEditMediumInMediaEditor(medium)
      } else {
        this.mediumInFocus = medium
        this.mediumBasicEditorVisible = true
      }
    },
    // drag-and-drop
    dragStart (item, $event) {
      if (
        !$event.ctrlKey &&
        !$event.metaKey &&
        !this.$store.state.Medium.media_selected_left.find(medium => medium.id === item.id)
      ) {
        this.$store.dispatch('Medium/clearMediaSelectedLeft')
      }
      this.$store.dispatch('Medium/addMediumSelectedLeft', item)
      this.$store.commit('Device/CLEAR_DESKTOPS_SELECTED_RIGHT')
      if (this.$store.state.Medium.media_selected_left.length < 2) return
      const img = new Image()
      img.src = 'static/many-media.svg'
      $event.dataTransfer.setDragImage(img, 10, 10)
    },
    async dragEnd (item, event) {
      if (this.selectedFolder) {
        this.playItemsSelected = []
        for (const mediumSelected of this.$store.state.Medium.media_selected_left) {
          const playitem = this.libraryFolder.PlayListItems.find(pi => pi.Medium.id === mediumSelected.id)
          this.playItemsSelected.push(playitem)
        }
        await this.__movePlayItemsToFolder(this.selectedFolder.id, true)
        return
      }
      if (this.$store.state.Medium.media_selected_right.length === 0 && this.$store.state.Device.desktops_selected_right.length === 0) return
      if (
        this.$store.state.Medium.drop_allowed === true &&
        this.$store.state.Medium.media_selected_right.length > 0 &&
        this.$store.state.User.rightPanelChosen === 'media'
      ) {
        this.$store.dispatch('Medium/setDropAllowed', false)
        await this.assignMediaToPlaylists()
        this.$emit('refreshPlaylist')
      }

      if (
        this.$store.state.Medium.media_selected_left.length > 0 &&
        this.$store.state.Device.desktops_selected_right.length > 0 &&
        this.$store.state.User.rightPanelChosen === 'devices'
      ) {
        const target = this.$store.state.Medium.local_playlists_cache.find(medium => medium.id === this.$store.state.Device.desktops_selected_right[0].LocalPlayList)
        for (const child of this.$store.state.Medium.media_selected_left) {
          await this.$store.dispatch('Medium/assignMediumToPlaylist', [target.id, child.id])
        }
        await this.$store.dispatch('Medium/getMedium', {
          data: target.id,
          options: { populate: true }
        })
        this.$emit('reloadLocalPlayLists')
      }
    },
    dragEnter (item, event) {
      this.$store.dispatch('Medium/setDropAllowed', false)
    },
    dragEnterFolder (item, event) {
      setTimeout(() => {
        this.selectedFolder = item
      }, 100)
    },
    dragLeaveFolder (item, event) {
      setTimeout(() => {
        this.selectedFolder = undefined
      }, 100)
    },
    // FIXME DRY
    filterByString (medium) {
      return medium.Medium.name.toLowerCase().indexOf(this.$store.state.Medium.search_by_string.toLowerCase()) > -1
    }
  },
  computed: {
    folderSelected () {
      return this.$store.state.Medium.selected_library_folder
    },
    folders () {
      if (!this.libraryFolder) return
      const folders = this.libraryFolder.PlayListItems.filter(pli => pli.Medium.type === 'PlayListLibraryFolder')
      return this.__sortPlayitemsByMediaPropierties(folders)
    },
    playlists () {
      if (!this.libraryFolder) return
      let items = this.libraryFolder.PlayListItems.filter(pli => pli.Medium.type.startsWith('PlayList') && pli.Medium.type !== 'PlayListLayout' && pli.Medium.type !== 'PlayListLibraryFolder')
      if (this.mediaTypeFilterActive.length) {
        const mediaIdsInTypeFilter = this.$store.state.Medium.media_types.find(mt => mt.name === this.mediaTypeFilterActive).media
        items = items.filter(i => mediaIdsInTypeFilter.includes(i.Medium.id))
      }
      if (this.$store.state.Medium.search_by_string.length > 0) {
        items = items.filter(pli => this.filterByString(pli))
      }
      if (this.viewModeUnlinked === 'unlinked') {
        items = items.filter(pli => this.$store.state.Medium.media_types.find(mt => mt.name === 'UnassignedMedia').media.includes(pli.Medium.id))
      }
      if (this.viewModeUnlinked === 'linked') {
        items = items.filter(pli => !this.$store.state.Medium.media_types.find(mt => mt.name === 'UnassignedMedia').media.includes(pli.Medium.id))
      }
      return this.__sortPlayitemsByMediaPropierties(items)
    },
    layouts () {
      if (!this.libraryFolder) return
      let items = this.libraryFolder.PlayListItems.filter(pli => pli.Medium.type === 'PlayListLayout')
      if (this.mediaTypeFilterActive.length) {
        const mediaIdsInTypeFilter = this.$store.state.Medium.media_types.find(mt => mt.name === this.mediaTypeFilterActive).media
        items = items.filter(i => mediaIdsInTypeFilter.includes(i.Medium.id))
      }
      if (this.$store.state.Medium.search_by_string.length > 0) {
        items = items.filter(pli => this.filterByString(pli))
      }
      if (this.viewModeUnlinked === 'unlinked') {
        items = items.filter(pli => this.$store.state.Medium.media_types.find(mt => mt.name === 'UnassignedMedia').media.includes(pli.Medium.id))
      }
      if (this.viewModeUnlinked === 'linked') {
        items = items.filter(pli => !this.$store.state.Medium.media_types.find(mt => mt.name === 'UnassignedMedia').media.includes(pli.Medium.id))
      }
      return this.__sortPlayitemsByMediaPropierties(items)
    },
    files () {
      if (!this.libraryFolder) return
      let items = this.libraryFolder.PlayListItems.filter(pli => pli.Medium.type.indexOf('PlayList') === -1)
      if (this.mediaTypeFilterActive.length) {
        const mediaIdsInTypeFilter = this.$store.state.Medium.media_types.find(mt => mt.name === this.mediaTypeFilterActive).media
        items = items.filter(i => mediaIdsInTypeFilter.includes(i.Medium.id))
      }
      if (this.$store.state.Medium.search_by_string.length > 0) {
        items = items.filter(pli => this.filterByString(pli))
      }
      if (this.viewModeUnlinked === 'unlinked') {
        items = items.filter(pli => this.$store.state.Medium.media_types.find(mt => mt.name === 'UnassignedMedia').media.includes(pli.Medium.id))
      }
      if (this.viewModeUnlinked === 'linked') {
        items = items.filter(pli => !this.$store.state.Medium.media_types.find(mt => mt.name === 'UnassignedMedia').media.includes(pli.Medium.id))
      }
      return this.__sortPlayitemsByMediaPropierties(items)
    },
    mediaFilteredByTag () {
      const mediaFilter = this.$store.state.Medium.media_filter[this.side]
      if (!this.$store.state.Medium.media_list || this.$store.state.Medium.media_list.length < 2) return []
      let mediaTags = mediaFilter.mediaTags
      let mediaAfterTagFilter = []
      if (!mediaFilter.mediaTagsAll) {
        // ANY TAGS
        for (let index = 0; index < mediaTags.length; index++) {
          mediaAfterTagFilter = mediaAfterTagFilter.concat(mediaTags[index].media)
        }
        mediaAfterTagFilter = [...new Set(mediaAfterTagFilter)]
      } else if (mediaFilter.mediaTagsAll && mediaTags.length > 0) {
        // ALL TAGS
        mediaAfterTagFilter = mediaTags[0].media
        for (let index = 1; index < mediaTags.length; index++) {
          // get ids from curent mediaTag
          let ids = mediaTags[index].media
          // filter mediaAfterTagFilter to only those in ids
          mediaAfterTagFilter = mediaAfterTagFilter.filter(value => ids.indexOf(value) !== -1)
        }
      }
      return mediaAfterTagFilter
    },
    inRootFolder () {
      return this.libraryFolder.type === 'PlayListLibraryRoot'
    },
    searchString: {
      get () {
        return this.$store.state.Medium.search_by_string
      },
      set (value) {
        this.$store.commit('Medium/UPDATE_SEARCH_STRING', value)
      }
    },
    omitCalculateDurations () {
      return this.viewMode === 'thumb'
    }
  }
}

</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.reloading-folder {
  opacity: 0.2;
}
.library {
  .test-medium {
    color: $--color-text-regular-green;
  }
  .icon-library.folder, .icon-library.file, .text-library, span.folder-name {
    user-select: none;
  }
  height: 80vh;
  border: 0px solid green;
  margin: 0px;
  padding: 0px;
  .upload {
    clear:left;
    padding-top: 10px;
  }
  .medium {
    overflow: hidden;
    max-width: 100%;
    &.row {
      width: 100%;
      border-top: $--border-light;
      display: flex;
      align-items: center;
      height: 50px;
      .cell {
        &.thumbnail {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 80px;
        height: 70px;
          .thumb-image {
            max-width: 60px;
            max-height: 60px;
            margin: auto;
            font-size: 40px;
            color: $--color-text-secondary;
            cursor: zoom-in;
          }
        }
        &.name {
          font-size: 11px;
          width: 35%;
          overflow: hidden;
          text-shadow:
            -1px -1px 2px #000,
            1px -1px 2px #000,
            -1px 1px 2px #000,
            1px 1px 2px #000;
          .rename-input {
            width: 90%;
            background-color: $--color-primary-light-1;
            border: 0px !important;
            color: $--color-text-primary;
            text-align: center;
          }
        }
        &.medium-tags {
          max-width: 30%;
        }
        &.params {
          width: 10%;
          font-size: $--font-size-small;
          color: $--color-text-secondary;
          display: flex;
          flex-direction: column;
          .param {
            // border: 1px solid green;
            // margin-right: 10px;
          }
        }
        &.medium-timeData {
          // width: 115px;
          font-size: $--font-size-small;
          color: $--color-text-secondary;
          margin-left: auto;
        }
      }
    }
    &.thumb {
      float: left;
      width: 100px;
      height: 100px;
      overflow: hidden;
      border: 0px solid rgba($--border-color-extra-light, 0.2);
      border-radius: 5px;
      margin: 4px;
      padding: 3px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      position: relative;
        .tagged {
          color: $--color-warning;
          left: 5px;
          top: 5px;
          position: absolute;
        }
        .folder {
          font-size: 44px;
          color: $--color-text-regular;
        }
        .cell {
          &.thumbnail {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            height: 60px;
            .thumb-image {
              max-width: 57px;
              max-height: 57px;
              margin-top: auto;
              font-size: 50px;
              color: $--color-text-secondary;
              &.icon {
                margin-bottom: -6px;
              }
            }
          }
          &.name {
            margin-bottom: 5px;
            font-size: 11px;
            text-align: center;
            text-shadow:
              -1px -1px 2px #000,
              1px -1px 2px #000,
              -1px 1px 2px #000,
              1px 1px 2px #000;
            .rename-input {
              width: 90%;
              background-color: $--color-primary-light-1;
              color: $--color-text-primary;
              text-align: center;
            }
          }
        }
    }
    &.selected {
      background-color: $--background-color-selected;
      font-weight: bold;
      font-size: 24px;
    }
  }
}
.top-row-container {
  display: flex;
  width:100%;
  // justify-content: space-between;
  align-items: center;
  margin: 0px;
  border: 0px solid red;
  .path {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    margin-top: 8px;
    color: $--color-text-secondary;
    width: 100%;
    cursor: pointer;
    .home {
      font-size: 15px;
    }
    span.folder-name {
      font-size: 11px;
      font-weight: bold;
    }
    .filter-by-type-button {
       margin-left: auto;
       margin-right: 0px;
       .view-mode {
         margin-right: 6px;
       }
    }
  }
}
.slash {
  color: $--color-primary-light-1;
  font-size: 10px;
  padding: 0px 9px;
}
.text-search {
  margin-left: 0px;
}
.filter-by-type-button {
  margin-left: 5px;
}
.tag-filter-icon {
  margin-left: 5px;
  &.active-filter-tags {
    color: $--color-warning;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/Library.vue